/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React from 'react';
import { useDrop } from "react-dnd";
import DraggableNumber from "./DraggableNumber";

interface NumberSlotProps {
  number: number;
  index: number;
  moveNumber: (fromIndex: number, toIndex: number) => void;
}

const NumberSlot: React.FC<NumberSlotProps> = ({ number, index, moveNumber }) => {
  const [, drop] = useDrop({
    accept: 'number',
    drop: (item: { index: number }) => moveNumber(item.index, index),
  });

  return (
    <div ref={drop} style={{
      width: '50px',
      height: '50px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '5px',
      backgroundColor: number ? 'lightblue' : 'lightgrey',
      border: '1px solid black'
    }}>
      {number && <DraggableNumber number={number} index={index} moveNumber={moveNumber} />}
    </div>
  );
};

export default NumberSlot;
